import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from '../NativeContainerElement.commonHtml.mjs';
import { Companion_getInstance22jtx90tar19r as Companion_getInstance } from '../NativeElement.mjs';
import { DismissSemantic_getInstanceoxgbstxq9t8s as DismissSemantic_getInstance } from '../../models/Theme.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DismissBackground$nativeWillAddChild$lambda(it) {
  it.stopImmediatePropagation();
  return Unit_instance;
}
function DismissBackground$onClick$lambda$slambda($action) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $($action($completion), $completion);
    return Unit_instance;
  }), 1);
}
function DismissBackground$onClick$lambda$slambda_0($action) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $($action($completion), $completion);
    return Unit_instance;
  }), 1);
}
var DismissBackgroundClass;
function DismissBackground() {
  if (DismissBackgroundClass === VOID) {
    class $ extends NativeContainerElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.themePipeline_1.add_6yb5u0_k$(Companion_getInstance().elementStyling_1, DismissSemantic_getInstance());
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
      nativeWillAddChild_kc1wyr_k$(element) {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = get_native(element);
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', DismissBackground$nativeWillAddChild$lambda);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            it.stopImmediatePropagation();
            return Unit_instance;
          };
        }
      }
      onClick_tk88x3_k$(action) {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.replaceEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp0_safe_receiver['on' + 'click'] = (it) => {
            launch(this, VOID, VOID, DismissBackground$onClick$lambda$slambda(action));
            return Unit_instance;
          };
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = 'on' + 'click';
          this_0.eventsBack_1[tmp_0] = (it) => {
            launch(this, VOID, VOID, DismissBackground$onClick$lambda$slambda_0(action));
            return Unit_instance;
          };
        }
      }
    }
    initMetadataForClass($, 'DismissBackground');
    DismissBackgroundClass = $;
  }
  return DismissBackgroundClass;
}
//region block: exports
export {
  DismissBackground as DismissBackground1nezyx9ss0e1b,
};
//endregion

//# sourceMappingURL=DismissBackground.commonHtml.mjs.map
